import { defineMessages } from 'react-intl';

export const messages: {
	for: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'townsquare.api.goal-state.archived': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'townsquare.api.goal-state.off-track': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'townsquare.api.goal-state.at-risk': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'townsquare.api.goal-state.on-track': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'townsquare.api.goal-state.pending': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'townsquare.api.goal-state.paused': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'townsquare.api.goal-state.completed': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'townsquare.api.goal-state.cancelled': {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	for: {
		id: 'search-page.atlas.goal.for',
		defaultMessage: 'for',
		description: 'The conjunction between a status and date e.g. "On track for August"',
	},
	'townsquare.api.goal-state.archived': {
		id: 'seaech-page.townsquare.api.goal-state.archived',
		defaultMessage: 'Archived',
		description:
			'The text is shown as a status badge on a goal search result card indicating the goal has been archived.',
	},
	'townsquare.api.goal-state.off-track': {
		id: 'seaech-page.townsquare.api.goal-state.off-track',
		defaultMessage: 'Off track',
		description:
			'The text is shown as a status badge on a goal search result card indicating the goal is off track.',
	},
	'townsquare.api.goal-state.at-risk': {
		id: 'seaech-page.townsquare.api.goal-state.at-risk',
		defaultMessage: 'At risk',
		description:
			'The text is shown as a status badge on a goal search result card indicating the goal is at risk.',
	},
	'townsquare.api.goal-state.on-track': {
		id: 'seaech-page.townsquare.api.goal-state.on-track',
		defaultMessage: 'On track',
		description:
			'The text is shown as a status badge on a goal search result card indicating the goal is on track.',
	},
	'townsquare.api.goal-state.pending': {
		id: 'seaech-page.townsquare.api.goal-state.pending',
		defaultMessage: 'Pending',
		description:
			'The text is shown as a status badge on a goal search result card indicating the goal is pending.',
	},
	'townsquare.api.goal-state.paused': {
		id: 'seaech-page.townsquare.api.goal-state.paused',
		defaultMessage: 'Paused',
		description:
			'The text is shown as a status badge on a goal search result card indicating the goal is paused.',
	},
	'townsquare.api.goal-state.completed': {
		id: 'seaech-page.townsquare.api.goal-state.completed',
		defaultMessage: 'Completed',
		description:
			'The text is shown as a status badge on a goal search result card indicating the goal has been completed.',
	},
	'townsquare.api.goal-state.cancelled': {
		id: 'seaech-page.townsquare.api.goal-state.cancelled',
		defaultMessage: 'Cancelled',
		description:
			'The text is shown as a status badge on a goal search result card indicating the goal has been cancelled.',
	},
});
